import { render, staticRenderFns } from "./PageHeadlineTitle.vue?vue&type=template&id=cdfeea90&scoped=true&"
import script from "./PageHeadlineTitle.vue?vue&type=script&lang=js&"
export * from "./PageHeadlineTitle.vue?vue&type=script&lang=js&"
import style0 from "./PageHeadlineTitle.vue?vue&type=style&index=0&id=cdfeea90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfeea90",
  null
  
)

export default component.exports